import { REDIRECT_AFTER_LOGIN } from '@app/app/shared/constants/constants';
import { CookieHelper } from '@app/app/shared/helpers/cookie-helper';
import { V3DialogService } from '@app/app/shared/helpers/dialog/v3-dialog.service';
import { UnauthenticateUser } from '@app/app/user-auth/store/user-auth.actions';
import { TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngxs/store';

export class LogoutHelper {
  static performLogout(store: Store): void {
    localStorage.removeItem(REDIRECT_AFTER_LOGIN);
    CookieHelper.DeleteCookie(REDIRECT_AFTER_LOGIN);
    store.dispatch(new UnauthenticateUser());
  }

  static confirmAndLogout(v3DialogService: V3DialogService, translocoService: TranslocoService, store: Store): void {
    v3DialogService
      .showConfirmDialog({
        title: translocoService.translate('translations.dialog.title.logout'),
      })
      .then((confirmed) => {
        if (confirmed) {
          LogoutHelper.performLogout(store);
        }
      });
  }
}
